"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DetailItem = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _useTranslations = require("../../hooks/useTranslations");
var _DetailItemCaption = require("../DetailItemCaption");
var _DetailItemImage = require("../DetailItemImage");
var _DetailItemReport = require("../DetailItemReport");
var _DetailItemShare = require("../DetailItemShare");
var _DetailItemShop = require("../DetailItemShop");
var _OlapicSliderButtons = require("../OlapicSliderButtons");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// istanbul ignore next - lazy
const DetailItemVideo = /*#__PURE__*/(0, _react.lazy)(async () => Promise.resolve().then(() => _interopRequireWildcard(require('../DetailItemVideo/DetailItemVideo'))));
const DetailItem = ({
  detailItem: {
    id,
    originalSource,
    uploader,
    caption,
    mediaType,
    products,
    reportPhotoUrl,
    isInstagram
  },
  detailItem,
  currentPosition,
  numberOfSlides,
  slide
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const {
    onOpen,
    onClose,
    open: isReportOpen
  } = (0, _presentationHooks.useDisclose)();
  const theme = (0, _mui.useTheme)();
  const isBreakpointLarge = (0, _mui.useMediaQuery)(theme.breakpoints.up('lg'));
  const isVideo = mediaType === 'video';
  const titleAreaContent = (0, _react.useMemo)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TitleArea, {
    component: "h3",
    variant: "h6",
    align: "center",
    color: "textPrimary",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.TitleLink, {
      "date-testid": getTestId(_constants.ORIGINAL_LINK),
      href: originalSource ?? '#',
      target: "_blank",
      rel: "noreferrer",
      variant: "h6",
      color: "textPrimary",
      children: [isInstagram ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TitleIcon, {}) : null, "@", uploader.name]
    })
  }), [getTestId, originalSource, isInstagram, uploader.name]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(`${_constants.DETAIL}-${id}`),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.MediaContainer, {
      children: [isVideo ? /*#__PURE__*/(0, _jsxRuntime.jsx)(DetailItemVideo, {
        detailItem: detailItem
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_DetailItemImage.DetailItemImage, {
        detailItem: detailItem
      }), isBreakpointLarge && isReportOpen ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_DetailItemReport.DetailItemReport, {
        reportPhotoUrl: reportPhotoUrl,
        onClose: onClose
      }) : null]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Content, {
      children: [isBreakpointLarge ? titleAreaContent : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.MobileTitleArea, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_OlapicSliderButtons.OlapicSliderButtons, {
          slide: slide,
          origin: "details",
          activeItem: currentPosition,
          maxSlideRange: numberOfSlides - 1
        }), titleAreaContent]
      }), caption ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_DetailItemCaption.DetailItemCaption, {
        caption: caption
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_DetailItemShop.DetailItemShop, {
        products: products ?? []
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Actions, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ReportButton, {
          "data-testid": getTestId(_constants.REPORT_BUTTON),
          variant: "text",
          color: "default",
          size: "medium",
          startIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ErrorCircle, {}),
          onClick: onOpen,
          children: translations.olapic2Report
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DetailItemShare.DetailItemShare, {
          itemId: id
        })]
      }), !isBreakpointLarge && isReportOpen ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_DetailItemReport.DetailItemReport, {
        reportPhotoUrl: reportPhotoUrl,
        onClose: onClose
      }) : null]
    })]
  });
};
exports.DetailItem = DetailItem;
